<template>
  <div class="users-out">
    <CDNTabs :tabs="tabs" />
    <div class="users-manage">
      <div class="menu-title">
        <div class="menu-right">
          <!--  -->
          <div class="filter-container" @click="filterClick">
            <CDNButton
              :BtnText="$t('common.search')"
              :hasBg="isFilter"
              :imgPath="require('@/assets/images/home/icon_search.png')"
            />
            <CDNButton
              :hasBg="isFilter"
              :imgPath="require('@/assets/images/products/icon_down.png')"
              innerstyle="margin-left: 5px;"
            />
          </div>
          <!--  -->

          <CDNButton
            :BtnText="$t('common.refresh')"
            innerstyle="margin-left: 24px;"
            :imgPath="require('@/assets/images/products/icon_refresh.png')"
            @btnclick="refresh"
          />

          <!-- <CDNButton
            :BtnText="$t('allDomain.applyCert')"
            :imgPath="require('@/assets/images/domain/icon_apply_cert.png')"
            innerstyle="margin-left: 24px;"
            @btnclick="appCert"
          /> -->
        </div>
      </div>
      <div class="input-container" v-show="isFilter">
        <loginInput
          :label="$t('allDomain.domain')"
          :appendIcon="require('@/assets/images/domain/icon_domain.png')"
          inputStyle="width: 288px;"
          realInputStyle="width: 288px;"
          @changeInput="(e) => (searchDomain = e)"
          :inputValue="searchDomain"
        />

        <ElementSelect
          ref="cert_status"
          :label="$t('certManage.certStatus')"
          innerStyle="margin-left: 24px;"
          :options="options"
          @selectValue="(e) => (certStatus = e)"
        />
        <ElementSelect
          ref="cert_type"
          :label="$t('certManage.type')"
          innerStyle="margin-left: 24px;"
          :options="applyTypeOptions"
          @selectValue="(e) => (certType = e)"
        />

        <ElementSelect
          ref="cert_auto_xq"
          :label="$t('certManage.autoRenew')"
          innerStyle="margin-left: 24px;"
          :options="autoXqOptions"
          @selectValue="(e) => (certAutoXq = e)"
        />
      </div>
      <div class="search-btn-content" v-show="isFilter">
        <CDNButton
          :hasBg="true"
          :imgPath="require('@/assets/images/products/prod_icon_search.png')"
          innerstyle="padding: 6px 20px;"
          :BtnText="$t('common.search')"
          @btnclick="searchClick"
        />
        <CDNButton
          :imgPath="require('@/assets/images/products/prod_icon_reset.png')"
          innerstyle="margin-left: 20px;padding: 6px 20px;"
          :BtnText="$t('common.reset')"
          @btnclick="resetClick"
        />
      </div>
      <!--  -->
      
      <el-table
       :data="tableData"
       height="500"
       style="width: 100%"
    @selection-change="selectedRows"
    >
        <el-table-column
          align="center"
          prop="host"
          :label="$t('allDomain.domain')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="ssl_issuer"
          :label="$t('certManage.certSource')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="ssl_type_Name"
          :label="$t('certManage.type')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="ssl_state_Name"
          :label="$t('certManage.certStatus')"
        >
        <template slot-scope="scope">
          
            <div>
              <el-popover
                placement="right"
                width="300"
                trigger="hover">
                <div><p>{{scope.row['ssl_remark']}}</p></div>
                <el-button type="text" size="mini" slot="reference">{{ scope.row['ssl_state_Name'] }}</el-button>
              </el-popover>
            </div>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="auto_ssl_Name"
          :label="$t('certManage.autoRenew')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="ssl_expired_Name"
          :label="$t('certManage.dueDate')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('product.handle')"
        >
        <template slot-scope="scope">
          
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('product.delete')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="danger"
                   @click="deleteClick(scope.row)"
                  icon="el-icon-delete"
                  circle
                ></el-button>
              </el-tooltip>
        </template>
        </el-table-column>
      </el-table>
      <!--  -->
      
      <div class="pagination-bottom">
        <Pagination
          :total="total"
          :page-size="pageSize"
          :page-count="pageCount"
          @change="handleChange"
        />
      </div>
      <!--  -->
      <!-- 申请证书弹框 -->
      <el-dialog title="" :visible.sync="dialogVisible" width="532px">
        <div class="dialog-content">
          <div>{{ $t("certManage.tip") }}:</div>
          <div>{{ $t("certManage.tipDes") }}</div>

          <div class="dialog-btn">
            <div @click="commitclick">{{ $t("certManage.commit") }}</div>
          </div>
        </div>
      </el-dialog>
      <!--  -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { certList, apiDeleteCert } from "@/service/requestRes";
let ssl_type_name = {
  0: '手动上传',
  1: 'http申请',
  2: 'dns申请'
};

let ssl_type_name_en = {
  0: 'Manual',
  1: 'Http',
  2: 'Dns'
};
let ssl_state_name = {
  '0': '手动上传无需处理',
  '1': '申请中（首次）',
  '2': '申请中（续期）',
  '3': '申请成功',
  '4': '处理完成',
  '-1': '超时',
};
let ssl_state_name_en = {
  '0': 'Manual upload does not need to be processed',
  '1': 'Application (First time)',
  '2': ' Application (renew)',
  '3': 'Successful',
  '4': 'Processing Completed',
  '-1': 'Time out',
};

let auto_ssl_name = {
  0: '手动',
  1: '自动',
};

let auto_ssl_name_en = {
  0: 'Manual',
  1: 'Auto',
};
export default {
  data() {
    return {
      dialogVisible: false,
      searchDomain: "",
      certStatus: "",
      certType: '',
      certAutoXq: '',
      inputValue: "1",
      isFilter: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      pageCount: 1,
      selectItems: [],
    };
  },

  computed: {
    headerLables() {
      return [
        { label: this.$t("allDomain.domain"), value: "host" },
        { label: this.$t("certManage.certSource"), value: "ssl_issuer" },
        { label: this.$t("certManage.type"), value: "ssl_type_Name" },
        { label: this.$t("certManage.certStatus"), value: "ssl_state_Name" },
        { label: `${this.$t("certManage.autoRenew")}`, value: "auto_ssl_Name" },
        { label: `${this.$t("certManage.dueDate")}`, value: "ssl_expired_Name" },
        { label: this.$t("product.handle"), value: "handle" },
      ];
    },
      applyTypeOptions() {
        return [
          {value: '', label: `${this.$t("certManage.all")}`},
          {value: '0', label: `${this.$t("certManage.ManualUpload")}`},
          {value: '1', label: `${this.$t("certManage.httpApply")}`},
          {value: '2', label: `${this.$t("certManage.dnsApply")}`},
        ];
      },
      autoXqOptions() {
        return [
          {value: '', label: `${this.$t("certManage.all")}`},
          {
          value: '0',
          label: `${this.$t("certManage.No")}`,
        },
        {
          value: '1',
          label: `${this.$t("certManage.Yes")}`,
        }
        ];
      },
      options() {
        return [
          {value: '', label: `${this.$t("certManage.all")}`},
        {
          value: "0",
          label: `${this.$t("certManage.Expire")}`,
        },
        {
          value: "1",
          label: `${this.$t("certManage.due")}`,
        },
        {
          value: "2",
          label: `${this.$t("certManage.normal")}`,
        },
        {
          value: "3",
          label: `${this.$t("certManage.applying")}`,
        },
        {
          value: "4",
          label: `${this.$t("certManage.applyingovertime")}`,
        },
      ];
      },
    tabs() {
      return [this.$t("certManage.certManage")];
    },
  },
  mounted() {
    this.getCertList({ page: 1 });
  },
  watch: {
    '$i18n.locale': function (e) {
    this.getCertList({ page: 1 });
    },
  },
  methods: {
    getCertList({
      page,
      start_date,
      end_date,
      host,
      ssl_type,
      auto_ssl,
      ssl_state,
    }) {
      certList({
        page,
        limit: this.pageSize,
        start_date,
        end_date,
        host,
        ssl_type,
        auto_ssl,
        ssl_state,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
      const { locale } = this.$i18n;
        const flag = (locale === 'en_US')
          this.tableData = list.data.map((item) => {
              return {
                ...item,
                ssl_type_Name: flag ? ssl_type_name_en[item.ssl_type] : ssl_type_name[item.ssl_type],
                ssl_state_Name: flag ? ssl_state_name_en[item.ssl_state] : ssl_state_name[item.ssl_state],
                auto_ssl_Name: flag ? auto_ssl_name_en[item.auto_ssl] : auto_ssl_name[item.auto_ssl],
                ssl_expired_Name: item.ssl_expired == 0 ? '': this.$moment(item.ssl_expired * 1000).format('YYYY-MM-DD HH:mm:ss'), 
              };
          });

        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    handleChange(e) {
      console.log("pagination", e);
    },
    selectedRows(items) {
      console.log(items);
      this.selectItems = items;
    },
    add() {
      console.log("add");
    },
    appCert() {
      this.dialogVisible = true;
    },
    refresh() {
      this.getCertList({ page: 1 });
    },
    deleteClick(item) {
      this.$confirm(this.$t('certManage.delete')+" "+ item.host+" "+ this.$t('certManage.tip1'), this.$t('certManage.delete'), {
        confirmButtonText: this.$t('allDomain.confirm'),
        cancelButtonText: this.$t('allDomain.cancel'),
        type: 'warning'
      }).then(() => {
        apiDeleteCert(item.host).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
          this.getCertList({ page: 1 });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
        });
        
      }).catch(() => {
      });
    },
    commitclick() {

    },
    filterClick() {
      this.isFilter = ! this.isFilter;
    },
    searchClick() {
      this.getCertList({page: 1, host: this.searchDomain, ssl_type: this.certType, auto_ssl: this.certAutoXq, ssl_state: this.certStatus});
    },
    resetClick() {
      this.searchDomain = "";
      this.certStatus = "";
      this.certType = "";
      this.certAutoXq = "";
      this.$refs.cert_status.value = '';
      this.$refs.cert_type.value = '';
      this.$refs.cert_auto_xq.value = '';
    },
  },
};
</script>
<style lang="scss" scoped>
.users-out {
  width: 1276px;
  margin: 24px auto;
}
.users-manage {
  background-color: white;
  padding: 0 24px 24px 24px;
  border-radius: 4px;
  .menu-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5a607f;
      a {
        font-family: PingFangSC-Semibold;
        font-size: 11px;
        color: #000000;
      }
    }
    .menu-right {
      height: 60px;
      display: flex;
      align-items: center;
    }
  }
  .filter-container {
    display: flex;
    align-items: center;
  }
  .input-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    flex-wrap: wrap;
  }
  .select-content {
    margin-left: 24px;
    &-title {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5a607f;
      letter-spacing: 0;
      margin-bottom: 4px;
    }
  }
  .search-btn-content {
    display: flex;
    margin-bottom: 49px;
  }


  .dialog-content {
    padding: 0 28px 28px 28px;
    margin-top: -20px;
    :nth-child(1) {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #131523;
    }
    :nth-child(2) {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #131523;
      margin-top: 19px;
    }
    .dialog-btn {
      width: 100%;
      margin-top: 40px;
      display: flex;
      :first-child {
        padding: 8px 35px;
        background: #d9e4ff;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #1e5eff;
        margin: 0 auto;
        cursor: pointer;
      }
    }
  }
  .handle-first {
    display: flex;
    align-items: center;
    :nth-child(1) {
      margin-right: 10px;
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      cursor: pointer;
    }
  }
}
</style>
